import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'defaultCurrency'
})
export class DefaultCurrencyPipe implements PipeTransform {

  transform(value: any): any {

    if (value == undefined) {
       value = '0.00';
    }
    return new Intl.NumberFormat('en-UK', { style: 'currency', currency: 'GBP' }).format(value);
  }

}
